import { slideRepository } from '../../infrastructure/repositories/SlideRepository';
import type { Slide, CreateSlideRequest, UpdateSlideRequest } from '../../domain/entities/Slide';

export class SlideService {
  async getSlides(activeOnly: boolean = false): Promise<Slide[]> {
    return await slideRepository.getSlides(activeOnly);
  }

  async getSlide(id: number): Promise<Slide> {
    return await slideRepository.getSlide(id);
  }

  async createSlide(data: CreateSlideRequest): Promise<Slide> {
    // Валидация
    this.validateSlideData(data);
    return await slideRepository.createSlide(data);
  }

  async updateSlide(id: number, data: UpdateSlideRequest): Promise<Slide> {
    return await slideRepository.updateSlide(id, data);
  }

  async deleteSlide(id: number): Promise<void> {
    return await slideRepository.deleteSlide(id);
  }

  async reorderSlides(slides: Array<{ id: number; order: number }>): Promise<void> {
    return await slideRepository.reorderSlides(slides);
  }

  private validateSlideData(data: CreateSlideRequest | UpdateSlideRequest): void {
    if ('title' in data && data.title && (data.title.length === 0 || data.title.length > 100)) {
      throw new Error('Title must be between 1 and 100 characters');
    }
    if ('subtitle' in data && data.subtitle && (data.subtitle.length === 0 || data.subtitle.length > 100)) {
      throw new Error('Subtitle must be between 1 and 100 characters');
    }
    if ('description' in data && data.description && (data.description.length === 0 || data.description.length > 500)) {
      throw new Error('Description must be between 1 and 500 characters');
    }
    if ('buttonText' in data && data.buttonText && (data.buttonText.length === 0 || data.buttonText.length > 50)) {
      throw new Error('Button text must be between 1 and 50 characters');
    }
  }
}

export const slideService = new SlideService();

